/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FileItemAliases {
  BUTTON_VIEW_EXTERNAL_EXAM = 'button-view-external-exam',
  CARD_CONTAINER_BODY_FILE_ITEM = 'card-container-body-file-item',
  CARD_CONTAINER_FILE_ITEM = 'card-container-file-item',
  CARD_CONTAINER_ZONE_DATE = 'card-container-zone-date',
  CARD_CONTAINER_ZONE_TITLE = 'card-container-zone-title',
  CARD_CONTAINER_ZONE_VIEW_EXTERNAL_EXAM = 'card-container-zone-view-external-exam',
  DECK_FILE_ITEM = 'deck-file-item',
  FETCH_DOCUMENTS = 'fetch-documents',
  FIELD_DATE = 'field-date',
  FIELD_DATE_LABEL = 'field-date-label',
  FIELD_PACS = 'field-pacs',
  FIELD_TITLE = 'field-title',
  LAYOUT_FILE_ITEM = 'layout-file-item',
  MAPPER_FILE_ITEM = 'mapper-file-item',
  PANEL_FILE_ITEM = 'panel-file-item',
  TEXT_DATE = 'text-date',
  TEXT_TITLE = 'text-title',
}
export { FileItemAliases };
